import React from 'react';
import { DataSubmissionForm } from 'components';

export const DataSubmissionPage = props => {
    return <DataSubmissionForm />;
};
